import React from 'react';
import { synth } from '../../engine/audioSynthesizer';
import ModalCloseButton from '../Modals/ModalCloseButton';
import { isNativeApp } from '../../utils/platform';

export default function SettingsModal({
  isOpen,
  onClose,
  isHandTrackingEnabled,
  setIsHandTrackingEnabled,
  showCameraPreview,
  setShowCameraPreview,
  goldenPoint,
  onToggleGoldenPoint,
  isSpeechEnabled = true,
  onToggleSpeech = () => {},
}) {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="modal-overlay"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="modal"
      >
        
        <ModalCloseButton onClick={onClose} label="Close settings" />

        {/* Header Title */}
        <h2 className="modal-title">
          Settings
        </h2>

        {/* Toggles */}
        <div className="settings-list">
          
          {/* 1. Read Out Scores Toggle */}
          <div className="settings-row">
            <span className="settings-row__label">
              Read out scores
            </span>
            <button
              onClick={onToggleSpeech}
              className={`settings-toggle ${isSpeechEnabled ? 'is-on' : ''}`}
              aria-pressed={!!isSpeechEnabled}
            >
              {isSpeechEnabled ? 'On' : 'Off'}
            </button>
          </div>

          {/* 2 + 3. Hand tracking + camera preview — native app only */}
          {isNativeApp && (
          <>
          {/* 2. Hand Tracking Toggle */}
          <div className="settings-row">
            <span className="settings-row__label">
              Hand tracking
            </span>
            <button
              onClick={() => setIsHandTrackingEnabled(prev => !prev)}
              className={`settings-toggle ${isHandTrackingEnabled ? 'is-on' : ''}`}
              aria-pressed={!!isHandTrackingEnabled}
            >
              {isHandTrackingEnabled ? 'On' : 'Off'}
            </button>
          </div>

          {/* 3. Show Camera Toggle */}
          <div className="settings-row">
            <span className="settings-row__label">
              Show camera
            </span>
            <button
              onClick={() => setShowCameraPreview(prev => !prev)}
              className={`settings-toggle ${showCameraPreview ? 'is-on' : ''}`}
              aria-pressed={!!showCameraPreview}
            >
              {showCameraPreview ? 'On' : 'Off'}
            </button>
          </div>
          </>
          )}

          {/* 4. Golden Point Toggle */}
          <div className="settings-row">
            <span className="settings-row__label">
              Golden Point
            </span>
            <button
              onClick={onToggleGoldenPoint}
              className={`settings-toggle ${goldenPoint ? 'is-on' : ''}`}
              aria-pressed={!!goldenPoint}
            >
              {goldenPoint ? 'On' : 'Off'}
            </button>
          </div>

          {/* 5. Test Audio & Voice Button */}
          <button
            onClick={() => {
              synth.playPoint('A');
              synth.speakScore('Testing Fifteen Love');
            }}
            className="btn btn-secondary btn-full settings-test"
          >
            <span className="btn-text">Test audio & voice</span>
          </button>

        </div>

      </div>
    </div>
  );
}
